import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output, inject } from '@angular/core';
import { OrtService } from '../../../../services/suchseite/ort.service';
import { OrtFacettenService } from '../../../../services/facetten/instance/ort-facetten.service';

@Component({
  selector: 'now-wbsuche-lib-ort-suche-ortsunabhaengig',
  imports: [CommonModule],
  styleUrl: './ort-suche-ortsunabhaengig.component.scss',
  templateUrl: './ort-suche-ortsunabhaengig.component.html'
})
export class OrtSucheOrtsunabhaengigComponent {
  private readonly ortFacettenService = inject(OrtFacettenService);
  private readonly ortService = inject(OrtService);

  @Output()
  public dataChange = new EventEmitter<void>();

  status$ = this.ortService.ortsunabhaengig$;
  ortsunabhaengigActive$ = this.ortService.ortsunabhaengigActive$;

  async toggleStatus(event: Event) {
    const input = event.target as HTMLInputElement;
    const ortsunabhaengig: boolean = input.checked;
    this.ortFacettenService.setOrtsunabhaenig(ortsunabhaengig);
    this.dataChange.emit();
  }
}
